import { useEffect } from 'react';

/** Prevents body scrolling while active (e.g. when a modal is open) */
export function useBodyScrollLock(active: boolean) {
  useEffect(() => {
    if (!active) return;

    const original = document.body.style.overflow;
    document.body.style.overflow = 'hidden';

    return () => {
      document.body.style.overflow = original;
    };
  }, [active]);
}
